var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappyFaceGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 13C10.3137 13 13 10.3137 13 6.99999C13 3.68629 10.3137 1 6.99999 1C3.68629 1 1 3.68629 1 6.99999C1 10.3137 3.68629 13 6.99999 13Z",
    stroke: "#81BC45",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15039 5.5C4.15039 5.30109 4.22941 5.11032 4.37006 4.96967C4.51071 4.82902 4.70148 4.75 4.90039 4.75C5.0993 4.75 5.29007 4.82902 5.43072 4.96967C5.57137 5.11032 5.65039 5.30109 5.65039 5.5",
    stroke: "#81BC45",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65039 5.5C8.65039 5.40151 8.66979 5.30398 8.70748 5.21299C8.74517 5.12199 8.80042 5.03931 8.87006 4.96967C8.9397 4.90003 9.02238 4.84478 9.11338 4.80709C9.20437 4.7694 9.3019 4.75 9.40039 4.75C9.49888 4.75 9.59641 4.7694 9.6874 4.80709C9.77839 4.84478 9.86107 4.90003 9.93072 4.96967C10.0004 5.03931 10.0556 5.12199 10.0933 5.21299C10.131 5.30398 10.1504 5.40151 10.1504 5.5",
    stroke: "#81BC45",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40015 8.53613C9.18218 8.96984 8.85132 9.33676 8.44241 9.59829C8.03349 9.85982 7.56163 10.0063 7.07649 10.0222C6.59136 10.0382 6.11089 9.92309 5.68566 9.68902C5.26043 9.45495 4.90617 9.11057 4.66016 8.69213",
    stroke: "#81BC45",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFaceGreen);
export default __webpack_public_path__ + "static/media/happy_face_green.f457973bd2ebceeb282707008574a3ac.svg";
export { ForwardRef as ReactComponent };